// KEEP IN SYNC WITH api/fathom/providers.py
export const FACEBOOK_PROVIDER = "fb";
export const FACEBOOK_FAKE_PROVIDER = "fbfake";
export const GOOGLE_PROVIDER = "google";
export const GOOGLE_FAKE_PROVIDER = "googlefake";
